import { render, staticRenderFns } from "./depositDetails.vue?vue&type=template&id=299691e4&scoped=true&"
import script from "./depositDetails.vue?vue&type=script&lang=js&"
export * from "./depositDetails.vue?vue&type=script&lang=js&"
import style0 from "./depositDetails.vue?vue&type=style&index=0&id=299691e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299691e4",
  null
  
)

component.options.__file = "depositDetails.vue"
export default component.exports